import React from 'react';

import { IconButton } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { getDesignToken, primitive, spacing } from 'styles/constants';

export const StyledButtonBox = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.buttonBox, style],
  });

export const StyledRecentOrderCard = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.recentOrderCard, style],
  });

export const AddIconButton = IconButton.withConfig<{
  disabled?: boolean;
}>(p => ({
  padding: 0,
  borderColor: p.disabled ? getDesignToken('icon-disabled') : getDesignToken('increment-active'),
  _icon: {
    color: p.disabled ? getDesignToken('text-disabled') : getDesignToken('increment-active'),
  },
}));

const styles = StyleSheet.create({
  buttonBox: {
    alignContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  recentOrderCard: {
    backgroundColor: getDesignToken('background-card'),
    borderBottomColor: primitive.$mayoEggWhite,
    borderBottomWidth: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$5,
  },
});
